export default __webpack_public_path__ + "static/media/services_active.8e5edb75.svg";